var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _circle4, _circle5, _path12, _path13, _circle6, _path14, _ellipse3, _path15, _path16, _path17, _path18, _circle7, _ellipse4, _path19, _path20, _path21, _path22, _circle8, _rect5, _rect6, _rect7, _rect8, _path23, _path24, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 391,
    viewBox: "0 0 582 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M598.527 206.698C598.527 269.494 543.985 320.4 476.703 320.4C409.422 320.4 354.88 269.494 354.88 206.698C354.88 143.903 409.422 92.9964 476.703 92.9964C543.985 92.9964 598.527 143.903 598.527 206.698Z",
    fill: "url(#paint0_linear_734_377)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M466.777 67.7292H484.825V96.606H466.777V67.7292Z",
    fill: "url(#paint1_linear_734_377)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 475.801,
    cy: 46.0721,
    r: 25.2671,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.606 329.424C549.372 329.424 607.551 275.286 607.551 208.503C607.551 168.125 586.283 132.369 553.602 110.406C550.567 108.367 546.96 107.387 543.304 107.387H411.907C408.251 107.387 404.644 108.367 401.609 110.406C368.929 132.369 347.66 168.125 347.66 208.503C347.66 275.286 405.839 329.424 477.606 329.424Z",
    fill: "url(#paint2_linear_734_377)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.132,
    cy: 286.06,
    rx: 9.555,
    ry: 17.9156,
    transform: "rotate(-44.9872 385.132 286.06)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.159 303.88C410.056 298.91 405.967 286.942 396.026 277.148C386.086 267.354 374.058 263.444 369.161 268.414C364.264 273.384 368.353 285.353 378.293 295.147C388.234 304.94 400.262 308.851 405.159 303.88ZM396.619 297.508C399.735 294.345 397.133 286.73 390.808 280.498C384.483 274.267 376.83 271.779 373.714 274.941C370.598 278.104 373.2 285.719 379.525 291.951C385.85 298.183 393.503 300.671 396.619 297.508Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.703 290.264L398.285 283.173L384.104 272.009L378.522 279.1L392.703 290.264ZM362.534 299.646L364.304 308.494L362.534 299.646ZM343.444 280.471C341.118 276.063 335.66 274.375 331.252 276.7C326.844 279.026 325.155 284.484 327.481 288.892L343.444 280.471ZM378.522 279.1C373.566 285.395 369.93 287.897 367.635 289.017C365.188 290.21 363.977 290.154 360.764 290.797L364.304 308.494C365.603 308.235 370.367 307.765 375.549 305.237C380.882 302.635 386.53 298.105 392.703 290.264L378.522 279.1ZM360.764 290.797C361.217 290.706 360.609 290.898 358.508 290.246C356.664 289.674 354.431 288.69 352.135 287.397C349.851 286.11 347.729 284.643 346.069 283.231C345.245 282.53 344.6 281.897 344.13 281.366C343.898 281.104 343.729 280.89 343.611 280.725C343.552 280.644 343.511 280.581 343.483 280.537C343.454 280.492 343.443 280.47 343.444 280.471L327.481 288.892C329.162 292.08 331.859 294.837 334.376 296.979C337.029 299.235 340.126 301.346 343.276 303.121C346.415 304.889 349.832 306.452 353.162 307.484C356.235 308.437 360.323 309.291 364.304 308.494L360.764 290.797Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M392.635 290.348L398.302 283.326L384.256 271.992L378.589 279.015L392.635 290.348ZM367.948 298.743L364.865 290.263L367.948 298.743ZM344.694 277.225C342.777 272.624 337.494 270.449 332.894 272.365C328.293 274.282 326.118 279.566 328.035 284.166L344.694 277.225ZM328.035 284.166C328.493 285.265 329.02 286.325 329.598 287.34L345.285 278.416C345.038 277.982 344.844 277.584 344.694 277.225L328.035 284.166ZM366.828 308.258C368.222 308.065 369.635 307.732 371.032 307.224L364.865 290.263C364.764 290.299 364.597 290.347 364.347 290.382L366.828 308.258ZM371.032 307.224C371.475 307.063 371.887 306.918 372.271 306.785L366.399 289.719C365.919 289.885 365.408 290.065 364.865 290.263L371.032 307.224ZM391.731 291.471C392.021 291.111 392.322 290.736 392.635 290.348L378.589 279.015C378.265 279.416 377.954 279.803 377.655 280.176L391.731 291.471Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.418 288.291C402.501 284.584 399.654 280.721 396.026 277.148C390.402 271.606 384.108 267.948 378.817 266.717L381.05 274.194C384.145 275.199 387.643 277.38 390.808 280.498C393.346 282.999 395.285 285.722 396.495 288.291H404.418Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.246,
    cy: 269.064,
    r: 19.1759,
    transform: "rotate(-30.6263 329.246 269.064)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.555,
    cy: 17.9156,
    rx: 9.555,
    ry: 17.9156,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 587.708 280.144)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.258 303.88C543.361 298.91 547.45 286.942 557.39 277.148C567.331 267.354 579.359 263.444 584.256 268.414C589.153 273.384 585.064 285.353 575.124 295.147C565.183 304.94 553.155 308.851 548.258 303.88ZM556.798 297.508C553.682 294.345 556.284 286.73 562.609 280.498C568.934 274.267 576.587 271.779 579.703 274.941C582.819 278.104 580.217 285.719 573.892 291.951C567.567 298.183 559.914 300.671 556.798 297.508Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M560.715 290.264L555.133 283.173L569.314 272.009L574.896 279.1L560.715 290.264ZM594.451 312.656L602.524 308.625H602.524L594.451 312.656ZM584.266 339.082C579.639 340.933 574.387 338.683 572.536 334.055C570.685 329.428 572.936 324.176 577.563 322.325L584.266 339.082ZM574.896 279.1C579.806 285.338 584.415 289.069 589.09 293.01C593.703 296.899 598.912 301.39 602.524 308.625L586.377 316.687C584.583 313.093 582.033 310.666 577.458 306.809C572.944 303.005 566.933 298.163 560.715 290.264L574.896 279.1ZM602.524 308.625C604.855 313.293 605.696 318.242 604.299 323.063C602.95 327.721 599.899 330.902 597.156 332.959C592.273 336.622 585.046 338.77 584.266 339.082L577.563 322.325C578.35 322.011 579.332 321.671 580.046 321.419C580.864 321.131 581.663 320.843 582.468 320.521C584.144 319.85 585.445 319.182 586.325 318.522C587.191 317.873 587.072 317.669 586.964 318.041C586.809 318.575 587.201 318.336 586.377 316.687L602.524 308.625Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M560.714 290.264L555.132 283.173L569.313 272.009L574.895 279.1L560.714 290.264ZM592.646 309.572L600.718 305.539L592.646 309.572ZM583.632 339.309C578.879 340.81 573.81 338.174 572.309 333.421C570.808 328.669 573.444 323.599 578.197 322.099L583.632 339.309ZM578.197 322.099C578.769 321.918 579.314 321.74 579.832 321.565L585.618 338.66C584.974 338.878 584.312 339.094 583.632 339.309L578.197 322.099ZM585.307 315.117C585.085 314.643 584.841 314.141 584.573 313.605L600.718 305.539C601.038 306.178 601.348 306.816 601.646 307.45L585.307 315.117ZM584.573 313.605C584.335 313.128 584.096 312.697 583.859 312.305L599.298 302.959C599.796 303.78 600.269 304.639 600.718 305.539L584.573 313.605ZM562.293 292.207C561.77 291.584 561.244 290.937 560.714 290.264L574.895 279.1C575.309 279.626 575.717 280.128 576.118 280.606L562.293 292.207Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.999 288.291C550.916 284.584 553.763 280.721 557.39 277.148C563.015 271.606 569.309 267.948 574.6 266.717L572.367 274.194C569.272 275.199 565.774 277.38 562.609 280.498C560.071 282.999 558.132 285.722 556.922 288.291H548.999Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.893,
    cy: 337.647,
    r: 19.1759,
    transform: "rotate(-30.6263 572.893 337.647)",
    fill: "#86B8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 468.582,
    y: 280.695,
    width: 2.70719,
    height: 18.9503,
    rx: 1.3536,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 484.825,
    y: 280.695,
    width: 2.70719,
    height: 18.9503,
    rx: 1.3536,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 476.703,
    y: 275.281,
    width: 2.70719,
    height: 32.4863,
    rx: 1.3536,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 363.363,
    y: 139.921,
    width: 209.356,
    height: 110.092,
    rx: 55.0462,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 7.21918
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 412,
    cy: 187,
    r: 15,
    fill: "#72B2FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 493.096,
    cy: 187,
    r: 15,
    fill: "#72B2FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5314 187.698C36.5314 250.494 91.0737 301.4 158.355 301.4C225.636 301.4 280.179 250.494 280.179 187.698C280.179 124.903 225.636 73.9964 158.355 73.9964C91.0737 73.9964 36.5314 124.903 36.5314 187.698Z",
    fill: "url(#paint3_linear_734_377)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M168.281 48.7292H150.233V77.606H168.281V48.7292Z",
    fill: "url(#paint4_linear_734_377)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2671,
    cy: 25.2671,
    r: 25.2671,
    transform: "matrix(-1 0 0 1 184.525 1.80493)",
    fill: "#000F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.453 310.424C85.686 310.424 27.5075 256.286 27.5075 189.503C27.5075 149.125 48.7757 113.369 81.4564 91.4064C84.491 89.3671 88.098 88.3872 91.7542 88.3872H223.151C226.807 88.3872 230.414 89.3671 233.449 91.4064C266.13 113.369 287.398 149.125 287.398 189.503C287.398 256.286 229.219 310.424 157.453 310.424Z",
    fill: "url(#paint5_linear_734_377)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.555,
    cy: 17.9156,
    rx: 9.555,
    ry: 17.9156,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 269.35 261.144)",
    fill: "#236DC1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.9 284.88C225.003 279.91 229.091 267.942 239.032 258.148C248.972 248.354 261 244.444 265.897 249.414C270.794 254.384 266.706 266.353 256.765 276.147C246.825 285.94 234.796 289.851 229.9 284.88ZM238.439 278.508C235.324 275.345 237.925 267.73 244.25 261.498C250.575 255.267 258.229 252.779 261.345 255.941C264.46 259.104 261.859 266.719 255.534 272.951C249.209 279.183 241.555 281.671 238.439 278.508Z",
    fill: "#468BDC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M242.355 271.264L236.773 264.173L250.954 253.009L256.536 260.1L242.355 271.264ZM272.524 280.646L270.755 289.494L272.524 280.646ZM291.615 261.471C293.94 257.063 299.399 255.375 303.807 257.7C308.215 260.026 309.903 265.484 307.578 269.892L291.615 261.471ZM256.536 260.1C261.492 266.395 265.128 268.897 267.423 270.017C269.87 271.21 271.081 271.154 274.294 271.797L270.755 289.494C269.456 289.235 264.692 288.765 259.51 286.237C254.176 283.635 248.529 279.105 242.355 271.264L256.536 260.1ZM274.294 271.797C273.841 271.706 274.449 271.898 276.55 271.246C278.394 270.674 280.627 269.69 282.923 268.397C285.207 267.11 287.33 265.643 288.989 264.231C289.814 263.53 290.459 262.897 290.929 262.366C291.16 262.104 291.33 261.89 291.448 261.725C291.506 261.644 291.548 261.581 291.576 261.537C291.604 261.492 291.615 261.47 291.615 261.471L307.578 269.892C305.896 273.08 303.2 275.837 300.682 277.979C298.03 280.235 294.933 282.346 291.782 284.121C288.643 285.889 285.226 287.452 281.896 288.484C278.824 289.437 274.735 290.291 270.755 289.494L274.294 271.797Z",
    fill: "#000F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M242.424 271.348L236.757 264.326L250.802 252.992L256.469 260.015L242.424 271.348ZM267.11 279.743L270.194 271.263L267.11 279.743ZM290.364 258.225C292.281 253.624 297.564 251.449 302.165 253.365C306.765 255.282 308.941 260.566 307.024 265.166L290.364 258.225ZM307.024 265.166C306.566 266.265 306.038 267.325 305.46 268.34L289.773 259.416C290.02 258.982 290.214 258.584 290.364 258.225L307.024 265.166ZM268.23 289.258C266.836 289.065 265.423 288.732 264.026 288.224L270.194 271.263C270.294 271.299 270.461 271.347 270.712 271.382L268.23 289.258ZM264.026 288.224C263.583 288.063 263.171 287.918 262.787 287.785L268.659 270.719C269.14 270.885 269.65 271.065 270.194 271.263L264.026 288.224ZM243.327 272.471C243.038 272.111 242.737 271.736 242.424 271.348L256.469 260.015C256.793 260.416 257.104 260.803 257.404 261.176L243.327 272.471Z",
    fill: "#0F4688"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.64 269.291C232.557 265.584 235.405 261.721 239.032 258.148C244.657 252.606 250.95 248.948 256.242 247.717L254.009 255.194C250.913 256.199 247.416 258.38 244.25 261.498C241.712 263.999 239.774 266.722 238.564 269.291H230.64Z",
    fill: "#468BDC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1759,
    cy: 19.1759,
    r: 19.1759,
    transform: "matrix(-0.860508 -0.509437 -0.509437 0.860508 332.083 243.332)",
    fill: "#85B7F2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.7734,
    cy: 267.06,
    rx: 9.555,
    ry: 17.9156,
    transform: "rotate(-44.9872 66.7734 267.06)",
    fill: "#236DC1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8002 284.88C91.6971 279.91 87.6084 267.942 77.6679 258.148C67.7273 248.354 55.6992 244.444 50.8023 249.414C45.9054 254.384 49.9941 266.353 59.9346 276.147C69.8752 285.94 81.9033 289.851 86.8002 284.88ZM78.2602 278.508C81.3761 275.345 78.7745 267.73 72.4494 261.498C66.1243 255.267 58.471 252.779 55.3551 255.941C52.2393 259.104 54.8409 266.719 61.1659 272.951C67.491 279.183 75.1444 281.671 78.2602 278.508Z",
    fill: "#468BDC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3438 271.264L79.9256 264.173L65.7447 253.009L60.1628 260.1L74.3438 271.264ZM40.6075 293.656L32.5341 289.625H32.5341L40.6075 293.656ZM50.7925 320.082C55.4198 321.933 60.6715 319.683 62.5224 315.055C64.3734 310.428 62.1227 305.176 57.4953 303.325L50.7925 320.082ZM60.1628 260.1C55.252 266.338 50.6438 270.069 45.9685 274.01C41.3549 277.899 36.1468 282.39 32.5341 289.625L48.6809 297.687C50.4755 294.093 53.0256 291.666 57.6006 287.809C62.114 284.005 68.125 279.163 74.3438 271.264L60.1628 260.1ZM32.5341 289.625C30.2031 294.293 29.3626 299.242 30.7591 304.063C32.1086 308.721 35.1598 311.902 37.9028 313.959C42.785 317.622 50.0124 319.77 50.7925 320.082L57.4953 303.325C56.7086 303.011 55.7261 302.671 55.0121 302.419C54.1948 302.131 53.3958 301.843 52.5905 301.521C50.914 300.85 49.613 300.182 48.7333 299.522C47.8676 298.873 47.9865 298.669 48.0943 299.041C48.2491 299.575 47.8577 299.336 48.6809 297.687L32.5341 289.625Z",
    fill: "#000F20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3443 271.264L79.9262 264.173L65.7452 253.009L60.1634 260.1L74.3443 271.264ZM42.4127 290.572L34.3399 286.539L42.4127 290.572ZM51.4268 320.309C56.1793 321.81 61.2485 319.174 62.7492 314.421C64.2499 309.669 61.6139 304.599 56.8614 303.099L51.4268 320.309ZM56.8614 303.099C56.2893 302.918 55.7448 302.74 55.2266 302.565L49.4405 319.66C50.0843 319.878 50.7464 320.094 51.4268 320.309L56.8614 303.099ZM49.7509 296.117C49.9732 295.643 50.2177 295.141 50.4856 294.605L34.3399 286.539C34.0207 287.178 33.7099 287.816 33.4126 288.45L49.7509 296.117ZM50.4856 294.605C50.7238 294.128 50.9622 293.697 51.1997 293.305L35.7602 283.959C35.2628 284.78 34.7897 285.639 34.3399 286.539L50.4856 294.605ZM72.7651 273.207C73.288 272.584 73.8144 271.937 74.3443 271.264L60.1634 260.1C59.7489 260.626 59.3411 261.128 58.94 261.606L72.7651 273.207Z",
    fill: "#0F4688"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0595 269.291C84.1428 265.584 81.2949 261.721 77.6679 258.148C72.0429 252.606 65.7496 248.948 60.4581 247.717L62.6909 255.194C65.7863 256.199 69.2842 258.38 72.4494 261.498C74.9874 263.999 76.9259 266.722 78.136 269.291H86.0595Z",
    fill: "#468BDC"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1759,
    cy: 19.1759,
    r: 19.1759,
    transform: "matrix(-0.860508 -0.509437 -0.509437 0.860508 88.4351 311.915)",
    fill: "#86B8F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.70719,
    height: 18.9503,
    rx: 1.3536,
    transform: "matrix(-1 0 0 1 166.477 261.695)",
    fill: "#5998E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.70719,
    height: 18.9503,
    rx: 1.3536,
    transform: "matrix(-1 0 0 1 150.233 261.695)",
    fill: "#5998E1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.70719,
    height: 32.4863,
    rx: 1.3536,
    transform: "matrix(-1 0 0 1 158.355 256.281)",
    fill: "#5998E1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.60959,
    y: -3.60959,
    width: 209.356,
    height: 110.092,
    rx: 55.0462,
    transform: "matrix(-1 0 0 1 275.305 124.531)",
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 7.21918
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M212.284 179.651C212.284 177.281 212.751 174.934 213.658 172.744C214.565 170.554 215.895 168.565 217.571 166.889C219.247 165.213 221.236 163.884 223.426 162.977C225.615 162.07 227.962 161.603 230.332 161.603C232.703 161.603 235.049 162.07 237.239 162.977C239.429 163.884 241.418 165.213 243.094 166.889C244.77 168.565 246.1 170.554 247.007 172.744C247.914 174.934 248.38 177.281 248.38 179.651",
    stroke: "#72B2FF",
    strokeWidth: 9.02397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.045 179.651C122.045 177.281 122.512 174.934 123.419 172.744C124.326 170.554 125.655 168.565 127.331 166.889C129.007 165.213 130.996 163.884 133.186 162.977C135.376 162.07 137.723 161.603 140.093 161.603C142.463 161.603 144.81 162.07 146.999 162.977C149.189 163.884 151.179 165.213 152.855 166.889C154.53 168.565 155.86 170.554 156.767 172.744C157.674 174.934 158.141 177.281 158.141 179.651",
    stroke: "#72B2FF",
    strokeWidth: 9.02397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_734_377",
    x1: 476.703,
    y1: 67.7292,
    x2: 476.703,
    y2: 320.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_734_377",
    x1: 476.703,
    y1: 67.7292,
    x2: 476.703,
    y2: 320.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_734_377",
    x1: 477.606,
    y1: 87.5818,
    x2: 477.606,
    y2: 329.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_734_377",
    x1: 158.355,
    y1: 48.7292,
    x2: 158.355,
    y2: 301.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_734_377",
    x1: 158.355,
    y1: 48.7292,
    x2: 158.355,
    y2: 301.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_734_377",
    x1: 157.453,
    y1: 68.5818,
    x2: 157.453,
    y2: 310.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.b059ab6315a79072fe62a3b8461918e8.svg";
export { ForwardRef as ReactComponent };